module.exports = __webpack_public_path__ + "static/img/betask-logo.76c2507.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/betask-logo.jpg
// module id = sOcK
// module chunks = 3